<template>
  <main class="container-fluid mb-110">
    <div class="row newTable select">
      <div class="col-12 search mb-3">
        <div class="titleStyle mt-5 mb-3">建立新的家戶</div>
        <div class="subTitleStyle mb-3">請確認成員身分與基本資料</div>
      </div>
      <div class="col-12">
        <mv-add-family-modify
          :familyrlType="'C'"
          ref="mvAddFamilyModify"
          :selectedFamily="[]"
          @save-items-data="checkDataM"
        />
      </div>
    </div>
    <mv-info :open="mvInfoOpen" @close="closeModal()">
      <div class="text font-20" slot="content">
        <div class="mt-10"> 原家戶戶長 <span style="color:#027a39;font-weight:600">{{ truncate(familyLeaderName,12) }}</span> 已重新歸戶，</div>
        <div class="text-red">需從原家戶剩下的家戶成員中，指定一位新戶長。</div>
      </div>
    </mv-info>
    <fixed-bottom>
      <template slot="@function">
        <div class="actions text-right">
          <a
            @click="$router.push({ name: prevRoute.name })"
            class="btn btn-default btn-custStyle mr-3"
            >取消</a
          >
          <a @click="createFamily" class="btn btn-primary btn-custStyle">建立</a>
        </div>
      </template>
    </fixed-bottom>
    <!-- 打開遮罩 -->
    <mv-mask :open="mvMaskOpen" :content="maskContent" />
  </main>
</template>

<script>
import moment from "moment";
import Avatar from "@/desktop/components/Avatar";
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import { mapGetters } from "vuex";
import {
  getFamilyMemberBycondition,
  getAllHouseholderBySales,
  addMembersToFamily,
  createNewFamily,
  getFamilyMemberByCsidNo,
} from "@/service";

import mvAddFamilyModify from "@/desktop/views/mv/components/mvAddFamilyModify";
import mvInfo from "@/desktop/views/mv/components/mvInfo";
import mvMask from "@/desktop/views/mv/components/mvMask";
import { log } from "util";
import FixedBottom from "@/desktop/views/mv/components/modal/fixedBotton";

export default {
  name: "createNewFamily",
  mixins: [commonMixin],
  data() {
    return {
      prevRoute: "",
      //彈窗
      mvInfoOpen: false,
      //戶長名字
      familyLeaderName: "",
      //遮罩
      mvMaskOpen: false,
      //遮罩字樣
      maskContent: "",
    };
  },
  components: { Avatar, mvAddFamilyModify, mvInfo, mvMask, FixedBottom },
  computed: {
    ...mapGetters(["BaseUrl", "FamilyResultFilter", "UserInfo"]),
    selectedHolder() {
      for (let i = 0; i < this.FamilyResultFilter.length; i++) {
        if (this.FamilyResultFilter[i].familyrl == 0) {
          return this.FamilyResultFilter[i].csidno;
        }
      }
    },
  },
  methods: {
    moment,
    ...mapActions([
      "updateUserItems",
      "updateAllHolderSearchData",
      "setPageLock",
    ]),
    checkDataM(val) {
      if (val !== "false" && val !== "true") {
        this.familyLeaderName = val;
        this.panelOpen("mvInfoOpen");
      } else if (val == "true") {
        this.maskContent = "資料更新中，請稍候...";
        this.panelOpen('mvMaskOpen');
        // 家戶關係進入則呼叫addMembersToFamily未歸戶成員或是非戶長成員重新歸戶，其餘統一是建立新的家戶
        const fn = this.prevRoute.name === 'relation' || this.prevRoute.name === 'customer-detail-2' ? addMembersToFamily : createNewFamily;
        fn(this.UserInfo.id, this.selectedHolder, this.FamilyResultFilter).then(result => {
          if (result.header && result.header.status == "200") {
            getFamilyMemberByCsidNo(this.UserInfo.id, this.selectedHolder).then(
              (csidresult) => {
                if (csidresult.header && csidresult.data) {
                  var familyLeader = csidresult.data.filter((obj) => {
                    return obj.familyrl === 0;
                  });
                  this.$toast.info({ title: "歸戶成功" });
                  this.updateUserItems(familyLeader[0]);
                  localStorage.userItems = JSON.stringify(familyLeader[0]);
                  this.$router.push({ name: this.prevRoute.name });
                }
              }
            );
            this.panelClose("mvMaskOpen");
          } else {
            this.$toast.info({ title: "歸戶失敗" });
            this.panelClose("mvMaskOpen");
          }
        });
      }
    },
    createFamily() {
      this.$refs.mvAddFamilyModify.saveItems();
    },
    closeModal() {
      this.panelClose("mvInfoOpen");
      this.$router.push({
        name: "changeFamilyLeader",
        params: { selectedHolder: this.selectedHolder },
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
};
</script>
<style lang="scss" scoped>
.titleStyle {
  font-family: PingFangTC;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #027a39;
}
.subTitleStyle {
  font-family: PingFangTC;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #323a45;
}

.btn-custStyle {
  padding-top:9px !important;
  width:120px;
  height: 40px;
}
.mb-110 {
  margin-bottom: 110px;
}
</style>